import React from 'react';
import { createRoot } from 'react-dom/client'; // Correct import
import App from './App';
import '@cloudscape-design/global-styles/index.css';
import './responsive.css';
import './config/axios-config'; // Global axios interceptors for token refresh
import { ThemeProvider } from './ThemeContext';
import { FeatureFlagsProvider } from './contexts/FeatureFlagsContext';

const container = document.getElementById('root');
const root = createRoot(container);
root.render(
  <ThemeProvider>
    <FeatureFlagsProvider>
      <App />
    </FeatureFlagsProvider>
  </ThemeProvider>
);